import { useEffect, useState } from "react";
import Select from 'react-select';
import { FormGroup, Label } from "reactstrap";
import { IDropdownOptionsModel } from "../../tsmodels/SharedModel";
import "./inputStyles.scss";

interface IDropdownInput {
  value: any;
  options?: any;
  isMulti?: boolean;
  name?: string;
  label?: string;
  className?: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: Function;
  onBlur?: Function;
  // handleOptionsSearch?: Function;
}

const DropdownInput = (props: IDropdownInput) => {
  // props
  const {
    value,
    options,
    isMulti,
    name,
    label,
    className,
    placeholder,
    required,
    disabled,
    onChange,
    onBlur
    // handleOptionsSearch,
  } = props;

  // states
  const [selectValue, setSelectValue] = useState<IDropdownOptionsModel[]>();

  // const promiseOptions = async (inputValue: string) =>
  //   await handleOptionsSearch(inputValue, options);

  useEffect(() => {
    setSelectValue(value)
  }, [JSON.stringify(value)])

  return (
    <FormGroup className={`input-field ${className ?? ""} selection`}>
      { label ? <Label>
        {label}
        {required && <span className="input-required">*</span>}
      </Label> : <></>}
      <Select
        id="select"
        name={name || "select"}
        className={`${className ?? ""} selectField`}
        classNamePrefix="selectField"
        value={selectValue}

        isMulti={isMulti || false}
        // cacheOptions
        options={options || []}
        // loadOptions={promiseOptions}
        onChange={(value: any) => {
          setSelectValue(value);
          onChange && onChange(value);
        }}
        onBlur={(event: any) => onBlur && onBlur(event)}
        isDisabled={disabled}
        placeholder={placeholder}
        isClearable={true}
        isSearchable={true}
        menuPosition="fixed"
      />
    </FormGroup>
  );
};

export default DropdownInput;
